import styled from 'styled-components';
import {controlWithIcon} from '../../../common/shared/control-with-icon.styled';

export const StyledTableWrapper = styled.div`
  ${controlWithIcon()}

  #section-to-print {
    position: ${({ partner }) => partner ? 'relative' : 'absolute'}; 
    bottom: ${({ partner }) => partner ? '' : '5000px'};
    width: 100%;
  }

  .icons-wrapper {
    .hidden-box {
      position: absolute;
      visibility: hidden;
      float: left;
      width: 1px;
      height: 1px;
      overflow: hidden;
    }
  }

  .noMargin {
    margin-top: 0
  }

  .disabled-link {
    pointer-events: none;
    color: #6A697C;
  }

  .amount {
    direction: ltr;
    border-left: ${({ ltr }) => ltr ? '' : '1px solid #A8C0FF'};
    border-right: ${({ ltr }) => ltr ? '' : 'none !important'};
  }

  .icons-wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-grow: 1;

    .col-sm-2 {
      display: flex;
      max-width: none
    }
  }
`